import React from 'react';
import { useNavigate } from 'react-router-dom';
import PlatformLayout from '../PlatformLayout';
import PlatformText from '../PlatformText';
import { getPlatformClass, getPlatformType } from '../../utils/platformUtils';
import './Receivables.css';

const MOBILE_APP_BAR_PLATFORMS = ['ios', 'android', 'ios-pwa', 'android-pwa'];

const ReceivablesLayout = ({ title, subtitle, backTo = '/orders', variant = 'default', children }) => {
  const navigate = useNavigate();
  const isMobileAppBar = MOBILE_APP_BAR_PLATFORMS.includes(getPlatformType());
  const shellClass = [
    'receivables-shell',
    variant === 'home' ? 'receivables-shell-home' : '',
    getPlatformClass()
  ].filter(Boolean).join(' ');

  return (
    <PlatformLayout className={shellClass}>
      <div className="container receivables-page">
        {/* profile-header-wrapper opts out of OrderManagement iOS safe-top padding */}
        <div className="profile-header-wrapper">
          {isMobileAppBar ? (
            <div className="mobile-app-bar">
              <button
                onClick={() => navigate(backTo)}
                className="back-icon-button"
                aria-label="Go back"
              >
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
              </button>
              <PlatformText variant="h1" className="profile-title">{title}</PlatformText>
            </div>
          ) : (
            <div className="saas-header">
              <button
                className="saas-back-button"
                onClick={() => navigate(backTo)}
                aria-label="Go back"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M19 12H5M12 19l-7-7 7-7" />
                </svg>
              </button>
              <div className="saas-header-content">
                <PlatformText variant="h1" className="saas-title">{title}</PlatformText>
                {subtitle && (
                  <PlatformText variant="body" className="saas-subtitle">{subtitle}</PlatformText>
                )}
              </div>
            </div>
          )}
        </div>
        <div className="receivables-content">
          {children}
        </div>
      </div>
    </PlatformLayout>
  );
};

export default ReceivablesLayout;
